module.exports = __webpack_public_path__ + "img/dvp.4bedc48a.svg";